// src/dynamicComponent.ts
import { CenteredSpinner, Error } from "@lb-lib/ui";
import PQueue from "p-queue";
import React, { useEffect, useRef, useState } from "react";
var queue = new PQueue({ concurrency: 1 });
var dynamicPage = (loader) => {
  let loadPromise = null;
  return (props) => {
    let [Component, setComponent] = useState(null);
    let [spinner, setSpinner] = useState(false);
    let [error, setError] = useState(false);
    let completedRef = useRef(false);
    useEffect(() => {
      if (loadPromise == null) {
        loadPromise = loader();
      }
      loadPromise.then((c) => {
        setComponent(() => c);
        completedRef.current = true;
      }).catch(() => setError(true));
      setTimeout(() => {
        if (!completedRef.current)
          setSpinner(true);
      }, 500);
    }, []);
    if (!Component && error)
      return React.createElement(Error, null, "Unable to load page");
    if (!Component && spinner) {
      return React.createElement(
        "div",
        {
          style: {
            marginTop: 20
          }
        },
        React.createElement(CenteredSpinner, null)
      );
    }
    if (Component)
      return React.createElement(Component, props);
    return null;
  };
};
var dynamicComponent = dynamicPage;
var dynamicFunction = (loader) => {
  let loadPromise = null;
  return async (...params) => {
    if (!loadPromise)
      loadPromise = loader();
    let fn = await loadPromise;
    return fn(...params);
  };
};
export {
  dynamicComponent,
  dynamicFunction,
  dynamicPage
};
//# sourceMappingURL=index.mjs.map